/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import AccountingsettingsList from "./AccountingsettingsList";
import AccountingGeneralSetting from "./AccountingGeneralSettings";
import AccountingReplay from "./AccountingReplay";
import YearEnding from "./YearEnding";
import { useTranslation } from "react-i18next";
import { Store } from "../../../utils/Store.js";

function TabPanel(props) {
  const { children, value, index } = props;

  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && (
        <Box p={3}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

export default function AccountingSettingsHome(props) {
  const { t } = useTranslation();
  const translate = t;
  const [value, setValue] = React.useState(0);
  const [isAdmin, setIsAdmin] = useState(false);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  useEffect(() => {
    let token = Store.get("w_refreshToken");
    if (Store.parseJwt(token).sub == "admin") {
      setIsAdmin(true);
    }
  }, []);

  return (
    <div>
      <Tabs value={value} onChange={handleChange}>
        <Tab label={translate("Chart Of Accounts")} />
        <Tab label={translate("General")} />
        <Tab label={translate("Close Accounts")} />
      </Tabs>
      <TabPanel value={value} index={0}>
        <AccountingsettingsList
          handleHomeClicked={props.handleHomeClicked}
          showMessage={props.showMessage}
          context={props.context}
        ></AccountingsettingsList>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <AccountingGeneralSetting
          handleHomeClicked={props.handleHomeClicked}
          showMessage={props.showMessage}
          context={props.context}
        ></AccountingGeneralSetting>
      </TabPanel>
      <TabPanel value={value} index={2}>
        <YearEnding
          handleHomeClicked={props.handleHomeClicked}
          showMessage={props.showMessage}
          setAlert={props.setAlert}
        ></YearEnding>
      </TabPanel>
    </div>
  );
}
